import { LabeledValue, TooltipText } from '@dreryk/react-components';

import { translationKeys } from '../translations';

import {
   useCqrsSearchAppointmentReceptionService,
   useReceptionServiceAsTooltipContent,
   useReceptionServicesAsText,
} from './ReceptionServicesDetails.hooks';

type ReceptionServicesDetailsProps = Readonly<{ appointmentId: number }>;

export const ReceptionServicesDetails = (props: ReceptionServicesDetailsProps): JSX.Element | null => {
   const { data: receptionServices, fetched: receptionServicesFetched } = useCqrsSearchAppointmentReceptionService(
      props.appointmentId
   );
   const receptionServicesAsText = useReceptionServicesAsText(receptionServices);
   const receptionServicesAsTooltipContent = useReceptionServiceAsTooltipContent(receptionServicesAsText);

   if (!receptionServicesFetched) {
      return null;
   }

   return (
      <LabeledValue
         label={translationKeys.receptionServices}
         value={
            receptionServicesAsText ? (
               <TooltipText testId={'receptionServices'} content={receptionServicesAsTooltipContent}>
                  <>{receptionServicesAsText.join(', ')}</>
               </TooltipText>
            ) : null
         }
         placeholder={translationKeys.notSelected}
         testId={'receptionServices'}
         overflow
         nowrap
      />
   );
};
